document.addEventListener("DOMContentLoaded", () => {
  const mapElement = document.getElementById("mainMap");
  if (mapElement) {
    const dataStart = mapElement.getAttribute("data-start");
    const title = mapElement.getAttribute("data-title");

    mapboxgl.accessToken =
      "pk.eyJ1IjoidmlhZGlncm91cCIsImEiOiJjbHdnOTI5cGQwMmp3MmpwYW9sMWp6bzF3In0.xZeoQnGcB-dSo6QyS46WhA";
    const map = new mapboxgl.Map({
      container: "mainMap", // container ID
      style: "mapbox://styles/mapbox/dark-v10", // style URL
      center: [9.8369221, 46.8083169], // starting position [lng, lat]
      zoom: 12, // starting zoom
    });

    // Disable zoom control through mouse scroll
    map.scrollZoom.disable();

    // Disable zoom through double-click
    map.doubleClickZoom.disable();

    // Disable zoom through touch controls (on mobile devices)
    map.touchZoomRotate.disable();

    const startCoordinates = dataStart
      .split(",")
      .map((coord) => parseFloat(coord.trim()));
    const start = startCoordinates; // Starting coordinates [lng, lat]
    const end = [9.8385807, 46.8065311]; // Ending coordinates [lng, lat]

    // Function to create a custom marker with text and icon
    function createCustomMarker(iconUrl, text, position, isStartMarker) {
      const markerElement = document.createElement("div");
      markerElement.className = "marker";

      // Create a container for the icon and text
      const markerContent = document.createElement("div");
      markerContent.style.display = "flex";
      markerContent.style.alignItems = "center";

      // Create and style the icon
      const icon = document.createElement("img");
      icon.src = iconUrl;
      icon.style.width = "20px"; // Set icon width
      icon.style.height = "20px"; // Set icon height
      icon.style.marginRight = "5px"; // Add margin to the right

      // Create and style the text
      const textElement = document.createElement("div");
      textElement.textContent = text;

      // Append icon and text to the container
      markerContent.appendChild(icon);
      markerContent.appendChild(textElement);

      // Append the content container to the marker
      markerElement.appendChild(markerContent);

      // Adjust the position with CSS if it's the start or end marker
      if (isStartMarker) {
        markerElement.style.left = "-90px"; // Move 70 pixels to the left of the purple dot
        markerElement.style.top = "-10px"; // Move 70 pixels to the left of the purple dot
        markerElement.style.maxWidth = "max-content"; // Move 70 pixels to the left of the purple dot
      } else {
        markerElement.style.left = "70px"; // Move 70 pixels to the right of the purple dot
      }

      // Add the marker to the map without offset
      new mapboxgl.Marker(markerElement).setLngLat(position).addTo(map);
    }

    // Add custom start marker with additional left offset
    createCustomMarker(
      "https://leotrippiwostg.wpenginepowered.com/wp-content/uploads/2024/08/leotrippi-logo.png",
      title,
      start,
      true
    );

    // Function to get route from Mapbox Directions API
    async function getRoute(start, end, profile = "driving") {
      const query = await fetch(
        `https://api.mapbox.com/directions/v5/mapbox/${profile}/${start[0]},${start[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
        { method: "GET" }
      );
      const json = await query.json();
      return json.routes[0];
    }

    async function updateDistanceData() {
      const drivingRoute = await getRoute(start, end, "driving");
      const walkingRoute = await getRoute(start, end, "walking");

      const drivingTime = (drivingRoute.duration / 60).toFixed(0); // Convert seconds to minutes
      const walkingTime = (walkingRoute.duration / 60).toFixed(0); // Convert seconds to minutes

      // Check if the element with id "distanceData" exists and update its content
      const distanceDataElement = document.getElementById("distanceData");
      if (distanceDataElement) {
        // Update the text content with walking and driving time information
        distanceDataElement.textContent = `Distance to Congress Center: ${walkingTime} minute walk / ${drivingTime} minute drive`;
      }

      // Check if the element with id "distanceDataContent" exists and update its content
      const distanceDataContentElement = document.getElementById(
        "distanceDataContent"
      );
      if (distanceDataContentElement) {
        // Update the text content with walking and driving time information
        distanceDataContentElement.textContent = `Distance to Congress Center: ${walkingTime} minute walk / ${drivingTime} minute drive`;
      }

      // Check if the element with id "propertiesDistanceDataContent" exists and update its content
      const propertiesDistanceDataContentElement = document.getElementById(
        "propertiesDistanceDataContent"
      );
      if (propertiesDistanceDataContentElement) {
        // Update the text content with walking and driving time information
        propertiesDistanceDataContentElement.textContent = `Distance to Congress Center: ${walkingTime} minute walk / ${drivingTime} minute drive`;
      }
    }

    map.on("load", () => {
      getRoute(start, end).then((route) => {
        const routeCoordinates = route.geometry.coordinates;
        const geojson = {
          type: "Feature",
          properties: {},
          geometry: {
            type: "LineString",
            coordinates: routeCoordinates,
          },
        };

        const streetLabelLayers = map
          .getStyle()
          .layers.filter(
            (layer) =>
              layer.type === "symbol" &&
              layer.layout["text-field"] &&
              layer["source-layer"] &&
              layer["source-layer"].includes("road")
          );

        streetLabelLayers.forEach((layer) => {
          map.setPaintProperty(layer.id, "text-color", "#FFFFFF");
        });

        // Calculate the midpoint of the route
        const midpoint = [(start[0] + end[0]) / 2, (start[1] + end[1]) / 2];

        // Adjust the map's center to the midpoint
        map.setCenter(midpoint);

        // Fit the route within the map's view
        const bounds = new mapboxgl.LngLatBounds(start, end);
        map.fitBounds(bounds, { padding: 150 });

        // Add driving time to the map
        const routeTime = (route.duration / 60).toFixed(0); // Convert seconds to minutes
        const centerRoute =
          routeCoordinates[Math.floor(routeCoordinates.length / 2)];
        new mapboxgl.Popup({ closeOnClick: false, focusAfterOpen: false })
          .setLngLat(centerRoute)
          .setHTML(`<div class="route-time">${routeTime} min drive</div>`)
          .addTo(map);

        if (map.getSource("route")) {
          map.getSource("route").setData(geojson);
        } else {
          map.addLayer({
            id: "route",
            type: "line",
            source: {
              type: "geojson",
              data: geojson,
            },
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#449fca",
              "line-width": 5,
              "line-opacity": 1,
            },
          });
        }

        map.addLayer(
          {
            id: "background",
            type: "background",
            paint: {
              "background-color": "#060b16",
            },
          },
          "water"
        );

        // Add a purple dot at the start of the route
        const startDot = document.createElement("div");
        startDot.style.width = "15px"; // Dot width
        startDot.style.height = "15px"; // Dot height
        startDot.style.backgroundColor = "#5123ff"; // Dot color
        startDot.style.borderRadius = "50%"; // Make it a circle
        startDot.style.boxShadow = "0 0 6px 3px #5123ff"; // Add purple box-shadow

        new mapboxgl.Marker(startDot).setLngLat(routeCoordinates[0]).addTo(map);

        // Add a purple dot at the end of the route
        const endDot = document.createElement("div");
        endDot.style.width = "15px"; // Dot width
        endDot.style.height = "15px"; // Dot height
        endDot.style.backgroundColor = "#5123ff"; // Dot color
        endDot.style.borderRadius = "50%"; // Make it a circle
        endDot.style.border = "2px solid white"; // Add white border
        endDot.style.boxShadow = "0 0 6px 3px #5123ff"; // Add purple box-shadow

        // Add the end marker with additional right offset
        new mapboxgl.Marker(endDot)
          .setLngLat(routeCoordinates[routeCoordinates.length - 1])
          .addTo(map);

        createCustomMarker(
          "https://leotrippiwostg.wpenginepowered.com/wp-content/uploads/2024/08/Wef-logo.png",
          "Congress\ncentre",
          end,
          false
        );
      });

      updateDistanceData();

      // Add points of interest layers using Mapbox Streets v8
      const categories = [
        { id: "hotel", filter: ["==", ["get", "maki"], "lodging"] },
        { id: "restaurant", filter: ["==", ["get", "maki"], "restaurant"] },
        { id: "hospital", filter: ["==", ["get", "maki"], "hospital"] },
        // { id: "parking", filter: ["==", ["get", "maki"], "parking"] },
      ];

      categories.forEach((category) => {
        map.addSource(`${category.id}-places`, {
          type: "vector",
          url: "mapbox://mapbox.mapbox-streets-v8",
        });

        map.addLayer({
          id: `${category.id}-poi`,
          type: "symbol",
          source: `${category.id}-places`,
          "source-layer": "poi_label",
          filter: category.filter,
          layout: {
            // "icon-image": `${category.id}-15`,
            "icon-allow-overlap": true,
            "text-field": ["get", "name"],
            "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
            "text-size": 0,
            "text-offset": [0, 1.25],
            "text-anchor": "top",
          },
          paint: {
            "text-color": "#FFFFFF",
          },
        });
      });

      // Get the current protocol (http or https), hostname (domain name), and port
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port ? ":" + window.location.port : "";

      // Construct the full URL for the restaurant, hospital, and hotel icons
      // const restaurantIconUrl = `${protocol}//${hostname}${port}/wp-content/uploads/2024/08/Markers-3.png`;
      // const hospitalIconUrl = `${protocol}//${hostname}${port}/wp-content/uploads/2024/08/Markers.png`;
      // const hotelIconUrl = `${protocol}//${hostname}${port}/wp-content/uploads/2024/08/Markers-1.png`;
      const restaurantIconUrl =
        "https://leotrippiwostg.wpenginepowered.com/wp-content/uploads/2024/08/Markers-3.png";
      const hospitalIconUrl =
        "https://leotrippiwostg.wpenginepowered.com/wp-content/uploads/2024/08/Markers.png";
      const hotelIconUrl =
        "https://leotrippiwostg.wpenginepowered.com/wp-content/uploads/2024/08/Markers-1.png";

      function addCustomMarkers(categoryId, iconUrl) {
        // Query rendered features to get features that are currently visible on the map
        const features = map.queryRenderedFeatures({
          layers: [`${categoryId}-poi`],
        });

        features.forEach((feature) => {
          const el = document.createElement("div");
          el.className = "custom-marker";
          el.style.backgroundImage = `url(${iconUrl})`;
          el.style.width = "30px";
          el.style.height = "30px";
          el.style.backgroundSize = "contain";

          new mapboxgl.Marker(el)
            .setLngLat(feature.geometry.coordinates)
            .addTo(map);
        });
      }

      map.on("idle", () => {
        addCustomMarkers("restaurant", restaurantIconUrl);
        addCustomMarkers("hospital", hospitalIconUrl);
        addCustomMarkers("hotel", hotelIconUrl); // Now using hotel icon
      });

      // Change the color of the buildings
      map.setPaintProperty("building", "fill-color", "#010612");
      map.setPaintProperty("landuse", "fill-color", "#060b16");
      map.setPaintProperty("water", "fill-color", "#1a222c");

      const roadLayers = map
        .getStyle()
        .layers.filter(
          (layer) =>
            layer.type === "line" &&
            layer["source-layer"] &&
            layer["source-layer"].includes("road")
        );
      roadLayers.forEach((layer) => {
        map.setPaintProperty(layer.id, "line-color", "#46505c");
      });

      setTimeout(() => {
        mapElement.blur();
      }, 0);
    });
  }
});
